var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLessEqual = function SvgLessEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "less_equal_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#less_equal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.027 6.905a1.5 1.5 0 0 0-1.053-2.81l-12 4.5a1.5 1.5 0 0 0 0 2.81l12 4.5a1.5 1.5 0 1 0 1.053-2.81L9.772 10zM6.027 13.596a1.5 1.5 0 1 0-1.053 2.809l12 4.5a1.5 1.5 0 1 0 1.053-2.81z"
  }))));
};
export default SvgLessEqual;